export default __webpack_public_path__ + "static/media/923.a1b3a315.png";